import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
import ListIntegrations from 'src/sections/overview/dashboards/views/admin/sso-integrations/view/list';
// ----------------------------------------------------------------------

export default function SsoIntegrationsList() {
    const { t } = useLocales()
    return (
        <>
            <Helmet>
                <title>{t('dashboard.admin.sso.title')}</title>
            </Helmet>

            <ListIntegrations />
        </>
    );
}
